// extracted by mini-css-extract-plugin
export default {"ActionBarLayer":"📚19-10-2QtxK6","NoActionBar":"📚19-10-2_EoEp"};